import { AuthMethod } from '../common/enums';
import { getIdentityClientSettings } from './localStorage';
import { store } from '../redux/store';

export function buildHttpHeaders(accessToken: string, backendHeader: string, contentType: string = 'application/json'): Record<string, string> {
    const state = store.getState();
    const user = state.userState.user;
    const employeeId = state?.userInformationState?.userInformation?.employeeId;
    const identitySettings = getIdentityClientSettings();
    const companyId = identitySettings.authMethod === AuthMethod.AzureB2C ? identitySettings.companyGuid : user?.profile?.company_id ?? '';
    const handymanApiUrl = identitySettings.authMethod === AuthMethod.AzureB2C ? identitySettings.handymanApiUrl : '';

    const headers: Record<string, string> = {
        Authorization: `Bearer ${accessToken}`,
        Backend: backendHeader,
        AuthMethod: identitySettings.authMethod
    };

    // Add Content-Type only if it's not multipart/form-data
    if (contentType && contentType.toLowerCase() !== 'multipart/form-data') {
        headers['Content-Type'] = contentType;
    }

    if (companyId) {
        headers.CompanyGuid = companyId;
    }

    if (handymanApiUrl) {
        headers.HandymanApiUrl = handymanApiUrl;
    }

    if (employeeId) {
        headers.EmployeeId = employeeId;
    }

    return headers;
}